import { ACTIVATION_URL } from "@/lib/links";

/**
 * Mobile sticky CTA bar — standardized to the site's single primary conversion
 * event ("Start Your Analysis") + the conversational alternative ("Ask Rhea").
 */
export default function MobileStickyCTA() {
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="md:hidden fixed bottom-0 inset-x-0 z-30 px-3 pb-3 pointer-events-none"
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
    >
      <div className="pointer-events-auto flex items-stretch gap-1.5 bg-card/95 backdrop-blur-md border border-border shadow-xl p-1.5">
        <button
          type="button"
          onClick={() => window.dispatchEvent(new Event("open-rhea-agent"))}
          data-testid="mobile-cta-rhea"
          className="flex items-center justify-center gap-2 px-4 py-3 flex-shrink-0 border border-border hover:bg-primary/10 transition-colors"
        >
          <img
            src="https://cdn.jotfor.ms/assets/agent-avatars/avatar_icon_79.png"
            alt=""
            className="h-5 w-5 rounded-full object-cover"
          />
          <span className="font-mono text-[0.62rem] uppercase tracking-[0.12em] font-semibold text-primary">
            Ask Rhea
          </span>
        </button>
        <a
          href={ACTIVATION_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-cta-assessment"
          className="flex-1 iw-btn-red flex items-center justify-center gap-2 px-3 py-3 text-[0.6rem]"
        >
          Start Your Analysis <span aria-hidden>→</span>
        </a>
      </div>
    </div>
  );
}
